const toOptionalNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

export const resolveMaxTickets = (event = {}) => {
  return toOptionalNumber(event.maxNumTickets ?? event.max_num_tickets);
};

export const shouldShowAvailability = (event = {}) => {
  if (typeof event.showAvailability === 'boolean') {
    return event.showAvailability;
  }

  const maxTickets = resolveMaxTickets(event);
  return maxTickets !== null && maxTickets > 0;
};

export const resolveAvailableTickets = (event = {}) => {
  const explicitAvailability = toOptionalNumber(
    event.availableTickets ?? event.available_tickets
  );

  if (explicitAvailability !== null) {
    return explicitAvailability;
  }

  const maxTickets = resolveMaxTickets(event);
  const soldOrReservedTickets = toOptionalNumber(
    event.numTickets ?? event.num_tickets
  );

  if (maxTickets === null || soldOrReservedTickets === null) {
    return null;
  }

  return Math.max(0, maxTickets - soldOrReservedTickets);
};
